<template>
  <div class="pay">
    <!--    全局成功页：当 background polling 检测到支付成功时，无论当前 logicType 是什么都展示-->
    <template v-if="showSuccess">
      <div class="repayment_over">
        <div class="repayment_over_img_box">
          <img class="repayment_over_img" src="@/assets/prokash/success.png" alt="" />
        </div>
        <div class="repayment_over_text">{{ $t('text_successful_repayment') }}</div>
        <div @click="back" class="repayment_over_btn">{{ $t('text_close') }}</div>
      </div>
    </template>

    <template v-else-if="!show">
      <!--    跳转逻辑-->
      <template v-if="logicType == 1">
        <JumpLogicComputer v-if="!isMoblie && pageData && Object.keys(pageData).length != 0" @expired="expired"
                           :pageData="pageData"
                           @refreshData="refreshData"></JumpLogicComputer>
        <JumpLogicMoblie v-if="isMoblie && pageData && Object.keys(pageData).length != 0" @expired="expired"
                         :pageData="pageData"
                         @refreshData="refreshData"></JumpLogicMoblie>
      </template>

      <!--    展示逻辑-->
      <template v-if="logicType == 2 && channelCode != 'linkedpay' && channelCode != 'cardpay' && channelCode != 'safaricom'">
        <DisplayLogicComputer v-if="!isMoblie && pageData && Object.keys(pageData).length != 0" @expired="expired"
                              :pageData="pageData"
                              @refreshData="refreshData" @showPopup="showPopup"></DisplayLogicComputer>
        <DisplayLogicMoblie v-if="isMoblie && pageData && Object.keys(pageData).length != 0" @expired="expired"
                            :pageData="pageData"
                            @refreshData="refreshData" @showPopup="showPopup"></DisplayLogicMoblie>
      </template>

      <!--    cardpay 专属展示逻辑（channelCode == 'cardpay'）-->
      <template v-if="logicType == 2 && channelCode == 'cardpay'">
        <DisplayLogicCardpayComputer v-if="!isMoblie && pageData && Object.keys(pageData).length != 0"
                                     @expired="expired" :pageData="pageData"
                                     @refreshData="refreshData" @showPopup="showPopup"></DisplayLogicCardpayComputer>
        <DisplayLogicCardpayMoblie v-if="isMoblie && pageData && Object.keys(pageData).length != 0"
                                   @expired="expired" :pageData="pageData"
                                   @refreshData="refreshData" @showPopup="showPopup"></DisplayLogicCardpayMoblie>
      </template>

      <!--    LinkedPay VA 展示逻辑（payType=2）-->
      <template v-if="logicType == 2 && channelCode == 'linkedpay'">
        <LinkedPayVAComputer v-if="!isMoblie && pageData && Object.keys(pageData).length != 0" @expired="expired"
                             :pageData="pageData"
                             @refreshData="refreshData" @paymentInitiated="onPaymentInitiated"></LinkedPayVAComputer>
        <LinkedPayVAMoblie v-if="isMoblie && pageData && Object.keys(pageData).length != 0" @expired="expired"
                           :pageData="pageData"
                           @refreshData="refreshData" @paymentInitiated="onPaymentInitiated"></LinkedPayVAMoblie>
      </template>

      <!--    Safaricom manual C2B PayBill 展示逻辑-->
      <template v-if="logicType == 2 && channelCode == 'safaricom'">
        <SafaricomPayBillComputer v-if="!isMoblie && pageData && Object.keys(pageData).length != 0" @expired="expired"
                                  :pageData="pageData" @paymentInitiated="onPaymentInitiated"></SafaricomPayBillComputer>
        <SafaricomPayBillMoblie v-if="isMoblie && pageData && Object.keys(pageData).length != 0" @expired="expired"
                                :pageData="pageData" @paymentInitiated="onPaymentInitiated"></SafaricomPayBillMoblie>
      </template>

      <!--    轮询逻辑-->
      <template v-if="logicType == 3">
        <RottenLogicPolling v-if="pageData && Object.keys(pageData).length != 0" @expired="expired" :pageData="pageData"
                            @refreshData="refreshData" @paymentInitiated="onPaymentInitiated"></RottenLogicPolling>
      </template>

      <!--    两阶段OTP确认-->
      <template v-if="logicType == 4">
        <TwoPhaseOtpComputer v-if="!isMoblie && pageData && Object.keys(pageData).length != 0" @expired="expired"
                             :pageData="pageData"
                             @refreshData="refreshData" @paymentInitiated="onPaymentInitiated"></TwoPhaseOtpComputer>
        <TwoPhaseOtpMoblie v-if="isMoblie && pageData && Object.keys(pageData).length != 0" @expired="expired"
                           :pageData="pageData"
                           @refreshData="refreshData" @paymentInitiated="onPaymentInitiated"></TwoPhaseOtpMoblie>
      </template>
    </template>
    <popup v-model="show"></popup>
    <FloatBall v-if="isParentLanguageBallVisible" :size="54">
      <img
        v-if="parentFloatBallImg"
        @click.stop="handleParentBallClick"
        @dragstart.prevent
        style="width: 100%;height: 100%;"
        :src="parentFloatBallImg"
        alt=""
      />
      <button v-else type="button" class="float-ball-text" @click.stop="handleParentBallClick">
        {{ parentFloatBallText }}
      </button>
    </FloatBall>
  </div>
</template>

<script>
import popup from "@/components/ExpiredPopup/index";
import FloatBall from "@/components/FloatBall";
import { THEME_CODE_FIELD } from "@/themes/constants";
import {
  getCountryLanguageConfig,
  getLanguageLabel,
  getNextLanguage,
  getSupportedCountryLanguages,
  setI18nLanguage,
  setLanguageByCountry,
} from "@/utils/languageAdapter";
import RottenLogicPolling from "./components/RottenLogic/polling";
import JumpLogicComputer from "./components/JumpLogic/computer";
import JumpLogicMoblie from "./components/JumpLogic/moblie";
import DisplayLogicComputer from "./components/DisplayLogic/computer";
import DisplayLogicMoblie from "./components/DisplayLogic/moblie";
import DisplayLogicCardpayComputer from "./components/DisplayLogicCardpay/computer";
import DisplayLogicCardpayMoblie from "./components/DisplayLogicCardpay/moblie";
import TwoPhaseOtpComputer from "./components/TwoPhaseOtpLogic/computer";
import TwoPhaseOtpMoblie from "./components/TwoPhaseOtpLogic/moblie";
import LinkedPayVAComputer from "./components/LinkedPayVALogic/computer";
import LinkedPayVAMoblie from "./components/LinkedPayVALogic/moblie";
import SafaricomPayBillComputer from "./components/SafaricomPayBillLogic/computer";
import SafaricomPayBillMoblie from "./components/SafaricomPayBillLogic/moblie";

export default {
  name: "checkoutPlatformReference",
  components: {
    RottenLogicPolling,
    JumpLogicComputer,
    JumpLogicMoblie,
    DisplayLogicComputer,
    DisplayLogicMoblie,
    DisplayLogicCardpayComputer,
    DisplayLogicCardpayMoblie,
    TwoPhaseOtpComputer,
    TwoPhaseOtpMoblie,
    LinkedPayVAComputer,
    LinkedPayVAMoblie,
    FloatBall,
    SafaricomPayBillComputer,
    SafaricomPayBillMoblie,
    popup
  },
  data() {
    return {
      pageData: {},
      order: undefined,
      curIndex: 0,

      isMoblie: false,
      show: false,
      showSuccess: false,

      paymentAccountNumber: undefined,

      timer: null,
      globalPollTimer: null,

      logicType: -1,
      channelCode: '',
      languageInitialized: false,
    };
  },
  computed: {
    channelCodeComputed() {
      return this.pageData?.configData?.channelCode || '';
    },
    countryInfo() {
      return this.pageData?.configData?.countryInfoVO || {};
    },
    parentSupportedLanguages() {
      return getSupportedCountryLanguages(this.countryInfo?.enName);
    },
    parentFloatBallImageKey() {
      const countryConfig = getCountryLanguageConfig(this.countryInfo?.enName);
      if (Object.prototype.hasOwnProperty.call(countryConfig, this.$i18n.locale)) {
        return countryConfig[this.$i18n.locale] || "";
      }
      return countryConfig[countryConfig.default] || "";
    },
    parentFloatBallImg() {
      const imageKey = this.parentFloatBallImageKey;
      if (!imageKey) return "";

      const themeFloatBallMap = this.themeImg('floatBallMap');
      if (themeFloatBallMap?.[imageKey]) return themeFloatBallMap[imageKey];

      try {
        return require(`@/components/FloatBall/${imageKey}.png`);
      } catch (error) {
        return "";
      }
    },
    isParentLanguageBallVisible() {
      return (
        this.countryInfo?.enName === 'TZ' &&
        this.logicType !== 2 &&
        this.parentSupportedLanguages.length > 1 &&
        !this.show &&
        !this.showSuccess
      );
    },
    parentFloatBallText() {
      return getLanguageLabel(
        getNextLanguage(this.$i18n.locale, this.parentSupportedLanguages)
      );
    },
  },
  methods: {
    debounce(func, delay = 1000, immediate = true) {
      let _this = this;
      //不能用箭头函数
      return function () {
        //在时间内重复调用的时候需要清空之前的定时任务
        if (_this.timer) {
          clearTimeout(_this.timer)
        }
        //适用于首次需要立刻执行的
        if (immediate && !_this.timer) {
          func.apply(this, arguments)
        }
        _this.timer = setTimeout(() => {
          func.apply(this, arguments)
        }, delay)
      }
    },
    zeroFill(value) {
      value = value.replace(" ", "");
      if (/^\d+$/.test(value)) {
        if (value.length == 9 && value[0] != 0) {
          value = "0" + value;
        }
      }
      return value;
    },
    checkPhone(value) {
      value = value.replace(" ", "");
      console.log("/^\\d+$/.test(value)", /^\d+$/.test(value))
      console.log(value.length, value[0], value.length == 10, value[0] == 0);
      if (/^\d+$/.test(value)) {
        if (value.length == 10 && value[0] == 0) {
          return true;
        } else if (value.length == 9 && value[0] != 0) {
          return true;
        }
      }
      return false;
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    expired() {
      this.pageData = {};
      this.show = true;
    },
    compareTime(gettime) {
      var today = new Date()  //获取当前时间
      gettime = gettime.replace(/-/g, '/');
      var endTime = new Date(gettime) //自己的时间
      if (today.getTime() > endTime.getTime()) {
        return true
      } else {
        return false
      }
    },
    formatNum(num) {
      //1. 可能是字符串，转换为浮点数
      //2. 乘以100 小数点向右移动两位
      //3. Math.round 进行四舍五入
      //4. 除以100 小数点向左移动两位 实现保留小数点后两位
      var value = Math.round(parseFloat(num) * 100) / 100;
      // 去掉小数点 存为数组
      var arrayNum = value.toString().split(".");
      //只有一位（整数）
      if (arrayNum.length == 1) {
        return value + ".00";
      }
      if (arrayNum.length > 1) {
        //小数点右侧 如果小于两位 则补一个0
        if (arrayNum[1].length < 2) {
          return value.toString() + "0";
        }
        return value;
      }
    },
    async init(platformReference) {
      // let res = await this.$http.checkoutInfo(platformReference);
      let res = await this.$http.appCheckout(platformReference);
      if (res.code == "200") {
        // res.data.data.expirationTime = "2023-11-30 15:59:30";
        this.pageData = res.data;
        this.logicType = this.pageData.configData.pageLogic;
        this.channelCode = this.pageData.configData.channelCode || '';
        this.applyCheckoutTheme();
        this.applyCheckoutLanguage();
        console.log("this.pageData", this.pageData)
        // this.pageData.collectedAmount = this.formatNum(this.pageData.collectedAmount+"");
        // if((this.pageData.transactionData && Object.keys(this.pageData.transactionData).length != 0)){
        //   this.pageData.remainTime = parseInt(parseInt(this.pageData.transactionData.remainTime));
        //   this.show = true;
        // }
        const expireTime = this.pageData.paymentData && this.pageData.paymentData.expireTime;
        if (expireTime !== undefined && expireTime !== null && expireTime !== '') {
          this.pageData.remainTime = parseInt(Number(expireTime));
          // this.show = true;
        }
        this.pageData.extraParams = this.pageData.configData.extraParams;
        // if (this.compareTime(this.pageData.expirationTime)) {

        if (Number.isFinite(this.pageData.remainTime) && this.pageData.remainTime <= 0) {
          this.show = true;
        }
      } else {
        this.show = true;
      }
      // let a = {
      //   "amount": "100000.00",
      //   "platformReference": "asdasd",
      //   "bankName": "abc bankabc bankabc bankabc bankabc bank",
      //   "accountName": "bvc",
      //   "accountNumber": "789789789789789789789789",
      //   "platformReference": "WENG231129101752nev7K",
      //   "expirationTime": "2023-11-30 09:55:04"
      // }
      // this.pageData = a;
      // console.log(this.pageData)
    },
    refreshData() {
      if (this.$route.params.platformReference) {
        this.init(this.$route.params.platformReference);
      }
    },
    showPopup(){
      this.show = true;
    },
    back() {
      window.opener = null;
      window.open("", "_self");
      window.close();
    },
    // 子组件完成 sys/initialize 后调用此方法，启动全局后台轮询
    onPaymentInitiated() {
      if (this.globalPollTimer) return;
      let _this = this;
      this.globalPollTimer = setInterval(async () => {
        if (!_this.pageData?.paymentData?.apiKey) return;
        try {
          const res = await _this.$http.transactionsQuery({
            apiKey: _this.pageData.paymentData.apiKey,
            platformReference: _this.$route.params.platformReference,
          });
          const status = res.data?.paymentStatus;
          if (status === 'PAID') {
            _this.showSuccess = true;
            clearInterval(_this.globalPollTimer);
            _this.globalPollTimer = null;
          } else if (status === 'FAILED' || status === 'EXPIRED') {
            clearInterval(_this.globalPollTimer);
            _this.globalPollTimer = null;
            _this.expired();
          }
        } catch (e) {
          // silently ignore polling errors
        }
      }, 3000);
    },
    stopGlobalPolling() {
      if (this.globalPollTimer) {
        clearInterval(this.globalPollTimer);
        this.globalPollTimer = null;
      }
    },
    /** 根据后台返回的 themeCode 加载主题，未返回时使用经典金 */
    applyCheckoutTheme() {
      const themeCode =
        this.pageData?.configData?.[THEME_CODE_FIELD] ??
        this.pageData?.configData?.themeCode;
      this.$store.dispatch('theme/applyTheme', themeCode || undefined);
    },
    applyCheckoutLanguage() {
      if (this.languageInitialized || this.countryInfo?.enName !== 'TZ') {
        return;
      }
      setLanguageByCountry(this.countryInfo.enName, this);
      this.languageInitialized = true;
    },
    handleParentBallClick() {
      const nextLang = getNextLanguage(
        this.$i18n.locale,
        this.parentSupportedLanguages
      );
      if (!nextLang) return;
      setI18nLanguage(nextLang, this);
    },
  },
  created() {
    // this.$router.push({ path: "/checkout" });
    // console.log("this.$route.params",this.$route.params)
    this.isMoblie = Boolean(this._isMobile());
    this.refreshData();
    // Global polling will start when child component emits 'paymentInitiated' after sys/initialize
    // this.init(JSON.parse(localStorage.getItem("androidData") || "{}"));
  },
  beforeDestroy() {
    this.stopGlobalPolling();
  },
  mounted() {
    let _this = this;
    window.onresize = function () {
      if (_this._isMobile()) {
        _this.isMoblie = true;
      } else {
        _this.isMoblie = false;
      }
    }
    if (this._isMobile()) {
      this.isMoblie = true;
    } else {
      this.isMoblie = false;
    }
  },
};
</script>

<style lang="scss" scoped>
//@import "@/views/components/GH/index.scss";

.pay {
  position: relative;
  // height: calc(100vh + 250px);
  //min-height: 100vh;
  // background: #F5F5F5;
}

.repayment_over {
  width: 100%;
  padding-top: 50px;
  text-align: center;

  .repayment_over_img_box {
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    .repayment_over_img {
      width: 50px;
      height: 50px;
      margin: 0 auto;
    }
  }

  .repayment_over_text {
    margin-top: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #029b00;
    text-align: center;
  }

  .repayment_over_btn {
    cursor: pointer;
    position: relative;
    margin: 0 auto;
    margin-top: 30px;
    width: calc(100% - 40px);
    height: 45px;
    background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
    border-radius: 8px;
    font-size: 15px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #996a30;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
